import React, { useState } from 'react';
import PropTypes from 'prop-types';

import CustomSidebar from './CustomSidebar';
import { CheckBox } from '../../../../../components/Form';

const MoveToMainWarning = ({ onConfirm, onClose, isDoubles }) => {
    const [check, setCheck] = useState(false);

    const toggleCheckbox = () => {
        setCheck(!check);
    };

    return (
        <CustomSidebar
            sidebarOpen={true}
            title={`Move ${isDoubles ? 'Team' : 'Player'} to Main`}
            handleOverlayClick={onClose}
        >
            <div className="text-danger fs14">
                You have reached the maximum number of players in this division.
            </div>
            <div className="div mt16 mb16" />
            <CheckBox
                controlled={true}
                id={`checkbox`}
                customLabel={`Move ${isDoubles ? 'team' : 'player'}  to Main and increase max ${isDoubles ? 'teams' : 'players'} by 1.`}
                checked={check}
                onChange={toggleCheckbox}
            />
            <div className="d-flex gap-8">
                <button
                    type="button"
                    className={'btn btn-primary btn-large mt-auto text-uppercase flex-1'}
                    disabled={!check}
                    onClick={onConfirm}
                    data-testid="event-profile.move-to-main-warning.apply-btn"
                >
                    Apply
                </button>
                <button
                    type="button"
                    className={'btn btn-default btn-large mt-auto text-uppercase flex-1'}
                    onClick={onClose}
                    data-testid="event-profile.move-to-main-warning.cancel-btn"
                >
                    Cancel
                </button>

            </div>
        </CustomSidebar>
    );
};

MoveToMainWarning.propTypes = {
    onConfirm: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    isDoubles: PropTypes.bool,
};

MoveToMainWarning.defaultProps = {
    isDoubles: false,
};

export default MoveToMainWarning;
